import api from 'api'

type CertificateListParams = {
  search?: string
}

const defaultParams = {
  search: '',
}

const certificatesList = ({
  search,
}: CertificateListParams = defaultParams) => {
  const params = {
    q: {
      search_name_cont: search,
    },
  }
  return api
    .get('/administration/certificates', {
      params,
    })
    .then(({ data }) => {
      return {
        data: data.data.map(({ attributes }: any) => attributes),
      }
    })
}

export default certificatesList
